import {emailRegex} from './constants'

export const checkEmailisValid = (email)=>{
    let WhiteSpaceRemovedEmail = email.trim()
    return emailRegex.test(WhiteSpaceRemovedEmail)
}